export const featureFlags = [
  "knowledgeHubConfigPage",
  "isChainOfThoughtEnabled",
  "showAllowUploadFileBeforeEscalation",
  "exploreV2HideTicketTitle",
  "showSimulatorIdInSimulator",
  "newAppLayout",
  "newSimulatorLeftPanel",
  "explore-widget",
  "browserSkill",
  "billingEnabled",
  "sopVisualizations",
  "suggestedReplyAui",
  "knowledgeBrandId",
  "snowflake-skills",
  "skill-connection",
  "basicDataInAdditionalContext",
  "displayDuplicateQaQuestions",
  "hardcodeFields",
  "skillMaxUsageInput",
  "articleAccessLabels",
  "exploreAsk",
  "questionscontextquackchat",
  "quackchatLayoutConfiguration",
  "reclassifyTopicOnSubsequentAnswers",
  "postTicketAnswerActions",
  "walkthroughgeneral",
  "hitlApprovalRequests",
  "goodResponsesLibrary",
  "goodResponsesLibraryFeedbackToggle",
  "notices",
  "syncEnrichments",
  "regressionTestsEnabled",
  "calculateTimeDifference",
  "login-enforcement",
  "aui-regression-tests",
  "gdpr-setting-page",
  "preChatSurvey",
] as const;
export type FeatureFlag = (typeof featureFlags)[number];
